if (!customElements.get("ds-discount-input-code")) {
  class DSDiscountInputCode extends HTMLElement {
    static isInitialized = false;

    constructor() {
      super();
      this.state = {
        isLoading: false,
        discountCode: "",
        messages: {
          default: this.dataset.defaultText || "",
          error: this.dataset.errorText || "",
          errorUsed: this.dataset.errorUsedText || "",
          success: this.dataset.successText || "",
        },
      };

      this.handleSubmit = this.handleSubmit.bind(this);
      this.checkForActiveDiscount = this.checkForActiveDiscount.bind(this);
    }

    get elements() {
      return {
        form: document.getElementById("ds-discount-code-form"),
        input: document.getElementById("ds-discount-code"),
        messageElement: document.querySelector(".ds-discount-code-text"),
        submitButton: document.querySelector('[name="apply_discount_code"]'),
        cartDrawer: document.querySelector("cart-drawer"),
      };
    }

    connectedCallback() {
      if (DSDiscountInputCode.isInitialized) {
        return;
      }

      DSDiscountInputCode.isInitialized = true;
      this.setupEventListeners();
      this.checkForActiveDiscount();

      localStorage.setItem("ds-discount-initialized", "true");
    }

    disconnectedCallback() {
      this.removeEventListeners();
    }

    setupEventListeners() {
      const { form } = this.elements;
      if (form && !form.hasAttribute("data-has-listener")) {
        form.addEventListener("submit", this.handleSubmit);
        form.setAttribute("data-has-listener", "true");
      }
    }

    removeEventListeners() {
      const { form } = this.elements;
      if (form) {
        form.removeEventListener("submit", this.handleSubmit);
      }
    }

    setLoading(loading) {
      const { submitButton } = this.elements;
      this.state.isLoading = loading;

      if (submitButton) {
        submitButton.setAttribute("aria-busy", loading);
        submitButton.disabled = loading;
      }
    }

    showMessage(type = "default", code = "") {
      const { messageElement } = this.elements;
      if (messageElement) {
        let message = this.state.messages[type] || this.state.messages.default;
        if (type === "success" && code) {
          message = message.replace("[code]", code.toUpperCase());
        }
        messageElement.textContent = message;
      }
    }

    async checkForActiveDiscount() {
      const activeCode = DSDiscountInputCode.getCookie("discount_code");
      if (activeCode && activeCode !== "clear") {
        const { input } = this.elements;
        if (input) {
          input.value = activeCode.toUpperCase();
          this.showMessage("success", activeCode);
        }
      } else {
        this.showMessage("default");
      }
    }

    static getCookie(name) {
      return document.cookie.split("; ").reduce((r, v) => {
        const [key, ...value] = v.split("=");
        return key === name ? decodeURIComponent(value.join("=")) : r;
      }, "");
    }

    static setCookie(name, value, days = 1) {
      const expires = new Date(Date.now() + days * 864e5).toUTCString();
      document.cookie = `${name}=${encodeURIComponent(
        value
      )}; expires=${expires}; path=/`;
    }

    async refreshCartData() {
      try {
        const response = await fetch("/cart.js");
        const cartData = await response.json();

        const { cartDrawer } = this.elements;
        if (cartDrawer?.refreshCart) {
          await cartDrawer.refreshCart();
        }

        return cartData;
      } catch (error) {
        console.error("Failed to refresh cart:", error);
        return null;
      }
    }

    async validateDiscountCode(code) {
      console.log("validateDiscountCode called with code:", code);
      if (!code || code.trim().length === 0) {
        console.log("Invalid code: empty or whitespace");
        return false;
      }

      const formattedCode = code.trim().toUpperCase();

      console.log("formattedCode", formattedCode);
      const cartBefore = await this.refreshCartData();

      // Speichere den aktuellen gültigen Code, falls vorhanden
      const previousValidCode = cartBefore?.discount_codes?.length > 0 ? cartBefore.discount_codes[0].code : null;
      console.log("previousValidCode", previousValidCode);
      

      try {
        const shopUrl = window.location.hostname;

        await fetch(`https://${shopUrl}/discount/${formattedCode}`, {
          method: "GET",
          mode: "no-cors",
          credentials: "include",
        });

        // Get the updated cart to reflect any discounts
        const cart = await this.refreshCartData();

        // Speichere den aktuellen Zustand des Warenkorbs
        const currentDiscount = cart.total_discount;
        const hasDiscountApplications =
          cart.cart_level_discount_applications &&
          cart.cart_level_discount_applications.length > 0;

        // Prüfe, ob der Rabattcode gültig ist
        if (currentDiscount > 0 || hasDiscountApplications) {
          console.log("Discount code was applied successfully");

          // Store the discount information
          this.total_discount = cart.total_discount;
          this.total_price_after_discount = cart.total_price;

          // Update discount status
          this.codeStatus = "valid";
          this.validDiscountCode = formattedCode;

          // Save the discount code to a cookie for persistence
          // _dsSetCookie("discount_code", formattedCode, 1);

          // Check for free shipping discount
          const hasFreeShipping =
            hasDiscountApplications &&
            cart.cart_level_discount_applications.some(
              (discount) =>
                discount.type === "shipping" ||
                (discount.value_type === "percentage" && discount.value === 100)
            );

          if (hasFreeShipping) {
            this.freeShippingFromDiscountCode = true;
            this.shippingCost = 0;
          }

          return true;
        } else {
          // Wenn der Code ungültig ist
          console.log("Invalid discount code");

          // Wenn es einen vorherigen gültigen Code gab, diesen wiederherstellen
          if (previousValidCode) {
            console.log("Restoring previous valid code:", previousValidCode);

            // Entferne den ungültigen Code
            await fetch(`https://${shopUrl}/discount/clear`, {
              method: "GET",
              mode: "no-cors",
              credentials: "include",
            });

            // Warte kurz, damit der Clear-Befehl wirksam wird
            await new Promise((resolve) => setTimeout(resolve, 300));

            // Wende den vorherigen gültigen Code wieder an
            await fetch(`https://${shopUrl}/discount/${previousValidCode}`, {
              method: "GET",
              mode: "no-cors",
              credentials: "include",
            });

            this.codeStatus = "valid";
          }

          return false;
        }
      } catch (error) {
        console.error("Error validating discount code:", error);

        // Bei Fehler den vorherigen Code wiederherstellen, falls vorhanden
        if (previousValidCode) {
          try {
            const shopUrl = window.location.hostname;

            // Entferne den ungültigen Code
            await fetch(`https://${shopUrl}/discount/clear`, {
              method: "GET",
              mode: "no-cors",
              credentials: "include",
            });

            // Warte kurz, damit der Clear-Befehl wirksam wird
            await new Promise((resolve) => setTimeout(resolve, 300));

            // Wende den vorherigen gültigen Code wieder an
            await fetch(`https://${shopUrl}/discount/${previousValidCode}`, {
              method: "GET",
              mode: "no-cors",
              credentials: "include",
            });
          } catch (restoreError) {
            console.error(
              "Error restoring previous discount code:",
              restoreError
            );
          }
        }

        return false;
      }
    }

    async refreshCart() {
      await new Promise((resolve) => setTimeout(resolve, 200));
      document.dispatchEvent(new CustomEvent("cart:refresh"));
    }

    async handleSubmit(event) {
      event.preventDefault();

      const { input } = this.elements;
      const code = input.value.trim();

      //console.log(input, 'input');
      //console.log(code.length, 'code');

      if (!code || code.length === 0) {
        this.showMessage("error");
        input.value = "";
        this.setLoading(false);
        return;
      }

      // Only set loading after we know we have a valid input
      this.setLoading(true);

      try {
        const existingCode = DSDiscountInputCode.getCookie("discount_code")
          .trim()
          .toUpperCase();
        if (existingCode === code.toUpperCase()) {
          this.showMessage("errorUsed");
          this.setLoading(false);
          return;
        }

        const discount = await this.validateDiscountCode(code);
        if (!discount) {
          throw new Error("Invalid discount code");
        }

        const shopUrl = window.location.hostname;
        await fetch(`https://${shopUrl}/discount/${code}`, {
          method: "GET",
          mode: "no-cors",
        });

        DSDiscountInputCode.setCookie("discount_code", code);
        this.showMessage("success", code);

        await this.refreshCart();
      } catch (error) {
        console.error("Discount application failed:", error);
        this.showMessage("error");
        input.value = "";
      } finally {
        this.setLoading(false);
      }
    }
  }

  customElements.define("ds-discount-input-code", DSDiscountInputCode);
}
